export default __webpack_public_path__ + "static/media/36M.19c90025.jpeg";